import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { FetchedData, genFetchedData } from '../../redux/fetchedData';
import { NotificationMessages } from './types';

export type NotificationState = {
  messages: FetchedData<NotificationMessages>;
  notificationIsRead: FetchedData<boolean>;
  setAllNotificationIsRead: FetchedData<boolean>;
};
const initialState: NotificationState = {
  messages: genFetchedData<NotificationMessages>(null),
  notificationIsRead: genFetchedData<boolean>(null),
  setAllNotificationIsRead: genFetchedData<boolean>(null),
};

const NotificationSlice = createSlice({
  name: 'notification',
  initialState,
  reducers: {
    setNotificationMessages(
      state,
      action: PayloadAction<NotificationState['messages']>,
    ) {
      state.messages = action.payload;
    },
    setNotificationIsRead(
      state,
      action: PayloadAction<NotificationState['notificationIsRead']>,
    ) {
      state.notificationIsRead = action.payload;
    },
    setAllNotificationIsRead(
      state,
      action: PayloadAction<NotificationState['setAllNotificationIsRead']>,
    ) {
      state.setAllNotificationIsRead = action.payload;
    },
  },
});

export const fetchGetAllNotificationForPeriod = createAction<{ date?: string }>(
  'notification/fetchGetAllNotificationForPeriod',
);

export const fetchSetNotificationIsRead = createAction<{ notification_id: number, isRemove?: boolean }>(
  'notification/fetchSetNotificationIsRead',
);

export const fetchSetAllNotificationIsRead = createAction(
  'notification/fetchSetAllNotificationIsRead',
);

export const initializeNotifications = createAction('notification/initialize');

export const {
  setNotificationMessages,
  setNotificationIsRead,
  setAllNotificationIsRead,
} = NotificationSlice.actions;
export const notificationReducer = NotificationSlice.reducer;
